module.exports = __webpack_public_path__ + "static/media/bell.3751cee6.svg";